import backArrow from '../../assets/left-arrow.svg';
import translations from './backButton.json';
import { Language } from '../helpers/directus';
import { createElement } from '../helpers/html';
import { HTMLAttributes } from 'react';

import './BackButton.css';

interface Attributes extends Omit<HTMLAttributes<'button'>, 'className'> {
    class?: string;
}

export interface BackButtonProps {
    container: HTMLElement;
    domains: string[];
    language: Language;
    attributes?: Attributes;
}

export default class BackButton {
    domains: string[];
    container: HTMLElement;
    language: Language;
    referrer: string;

    constructor({ container, domains, language, attributes }: BackButtonProps) {
        this.domains = domains;
        this.container = container;
        this.language = language;
        this.referrer = this.prepareUrl(document.referrer);

        if (this.allowRenderBackButton)
            this.render(attributes as Record<string, string>);

        this.prepareUrl = this.prepareUrl.bind(this);
    }
    private render(attributes: Record<string, string>) {
        const root = createElement<HTMLDivElement>('div', '', {
            ...attributes,
            class: `back-root ${attributes?.class ?? ''}`,
        });

        const container = createElement<HTMLDivElement>('div', '', {
            class: 'back-container',
        });

        const button = createElement<HTMLButtonElement>(
            'button',
            `${translations[this.language].bactTo} `,
            { class: 'back-button' }
        );

        button.innerHTML = `${backArrow} ${
            translations[this.language].bactTo
        } <span class="back-button-bold">&nbsp;${this.referrer}</span>`;

        button.addEventListener('click', () => {
            window.location.href = this.backUrl;
        });

        container.append(button);
        root.append(container);
        this.container.prepend(root);
    }

    private get backUrl() {
        const backParamUrl = new URLSearchParams(window.location.search).get(
            'back'
        );
        if (!backParamUrl) return document.referrer;

        return this.checkIsAllowedUrl(backParamUrl)
            ? backParamUrl
            : document.referrer;
    }

    private prepareUrl(url: string) {
        const result = url.split('/')[2] || '';
        return result.replace(/^www\./, '');
    }

    private get allowRenderBackButton() {
        if (!document.referrer) return false;
        return this.checkIsAllowedUrl(document.referrer);
    }

    private checkIsAllowedUrl(url: string) {
        const preparedUrl = this.prepareUrl(url);

        if (!preparedUrl) return false;

        return !!this.domains.find((d) => this.prepareUrl(d) === preparedUrl);
    }
}
